import { corporateRequirementSatisfied } from "./corporateDocumentRequirements";

const normalizedLabel = (value) => String(value || "")
  .normalize("NFKD").replace(/[\u0300-\u036f]/g, "")
  .replace(/\([^)]*\)/g, " ")
  .toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();

function documentType(value) {
  const label = normalizedLabel(value);
  if (["trade licence", "trade license", "commercial licence", "commercial license", "business licence", "business license"].includes(label)) return "trade_licence";
  if (["memorandum of association", "moa"].includes(label)) return "memorandum_of_association";
  if (["certificate of incorporation", "incorporation certificate"].includes(label)) return "certificate_of_incorporation";
  return label;
}

// A group-level approval proves that a file was accepted, not that every
// corporate document in that group was received. Use its identified type only.
export function corporateDocumentItemKeys(approvedFile, requirement) {
  const items = requirement?.docs || [];
  const keys = new Set();
  const files = Array.isArray(approvedFile?.relatedApprovedFiles)
    ? approvedFile.relatedApprovedFiles : approvedFile ? [approvedFile] : [];
  for (const file of files) {
    if (file?.review?.status && file.review.status !== "approved") continue;
    const result = file?.corporateDocumentCheck || file?.documentClassificationCheck || {};
    const extracted = result.extracted || result.extractedData || {};
    const check = (result.checks || []).find((entry) => entry.type === "corporate_document_type") || {};
    const matchedLabel = check.matchedExpectedDocumentLabel || check.matched_expected_document_label || extracted.matched_expected_document_label;
    const confidentMatch = extracted.is_one_of_expected_document_types === true &&
      Number(check.matchConfidence ?? extracted.match_confidence ?? 0) >= 0.75;
    const identifiedType = confidentMatch && matchedLabel ? matchedLabel :
      check.identifiedDocumentType || check.identified_document_type ||
      extracted.semantic_document_type || extracted.identified_document_type ||
      extracted.document_type || extracted.documentType || extracted.visible_document_title ||
      file?.review?.requirementText;
    const type = documentType(identifiedType);
    const matches = type ? items.filter((item) =>
      [item.label, item.secondaryLabel].some((label) => documentType(label) === type)
    ) : [];
    if (matches.length === 1) keys.add(matches[0].key);
    // The generic fallback is a single requirement, not a list of alternatives.
    else if (requirement?.fallback && items.length === 1) keys.add(items[0].key);
  }
  return [...keys];
}

export function corporateRegWithApprovedDocuments(regDoc = {}, requirement, approvedFile) {
  const items = { ...(regDoc.items || {}) };
  for (const key of corporateDocumentItemKeys(approvedFile, requirement)) {
    const item = requirement.docs.find((entry) => entry.key === key);
    items[key] = { ...items[key], ...item, obtained: true };
  }
  const requiredItems = requirement?.docs || [];
  return { ...regDoc, items, obtained: requiredItems.length ?
    corporateRequirementSatisfied({ items }, requirement) : !!regDoc.obtained };
}
